module.exports = (__webpack_require__(7))(462);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/sockjs-client/lib/entry.js from dll-reference vendor
// module id = 1232
// module chunks = 0